import React from 'react';
import {
  Modal,
  Input,
  Button,
  Select,
  Icon,
  Col,
  Row,
  DatePicker,
  Tooltip
} from 'antd';
import DisabledPopup from './disabledPopup.js';
import moment from 'moment';
const { TextArea } = Input;
const Option = Select.Option;

class Preparation extends React.Component {
  state = {
    who: '',
    where: '',
    when: '',
    how: '',
    completion: null,
    notes: '',
    disabledPopup: false
  };

  componentWillUnmount = () => {
    this.saveData();
  };

  isDisabled = () => {
    const { who, where, when, how, completion } = this.state;
    if (
      who == '' ||
      where == '' ||
      when == '' ||
      how == '' ||
      completion == ''
    ) {
      return true;
    } else if (!this.props.disabled) {
      return false;
    }
  };

  componentDidMount = () => {
    const { data } = this.props;
    if (data && data.is_complete) {
      this.setState({
        who: data.who,
        where: data.where,
        when: data.when,
        how: data.how,
        completion: moment(data.expectedCompletionDate * 1000),
        notes: data.notes
      });
    } else {
      this.setState({
        completion: moment()
      });
    }
  };

  saveData = toNextPhase => {
    const { who, where, when, how, completion, notes } = this.state;
    const data = {
      Preparation: {
        expectedCompletionDate: moment(completion).unix(),
        how: how,
        is_complete: true,
        notes: notes,
        when: when,
        where: where,
        who: who
      }
    };
    if (toNextPhase) {
      data.current_phase = 'Action';
    }
    this.props.saveData(data);
  };

  render() {
    const { color, t, disabled, projectCompleted } = this.props;

    const styles = {
      titleDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      },
      title: {
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        alignSelf: 'left'
      },
      addMultiple: {
        backgroundColor: 'white',
        borderRadius: 20,
        height: 45,
        marginTop: 10,
        position: 'relative',
        border: `1px solid ${color}`,
        cursor: 'pointer'
      },
      nextBtn: {
        fontSize: 16,
        backgroundColor: this.props.color,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'pointer'
      },
      disabledNextBtn: {
        fontSize: 16,
        backgroundColor: '#d0d0d0',
        width: '100%',
        position: 'fixed',
        bottom: 0,
        textAlign: 'center',
        color: 'white',
        padding: 10,
        cursor: 'not-allowed'
      }
    };

    return (
      <div style={{ position: 'absolute', width: '100%', top: 260 }}>
        <div style={{ maxWidth: 650, margin: '0 auto', paddingBottom: 70 }}>
          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Who (Which organization(s))?')}</h3>
            <Tooltip title="List the organization and/or contact person you're working with">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ who: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.who}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Where (Which location(s))?')}</h3>
            <Tooltip title="Write down the location where your project takes place. This may be online if you are doing research or advocacy">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              disabled={disabled || projectCompleted}
              rows={4}
              onChange={e => this.setState({ where: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.where}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t('When (Which timeframe / frequency)?')}
            </h3>
            <Tooltip title="This can be a specific time (eg every Monday afternoon) or it can be a goal (eg twice a week for 8 weeks)">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ when: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.when}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>
              {t('How (What resources will I need)?')}
            </h3>
            <Tooltip title="What tools or materials will you need for the project?">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={4}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ how: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.how}
            />
          </div>

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Expected completion date')}</h3>
            <Tooltip title="This can be an estimate or a specific date.">
              <img style={{ height: 16, width: 16 }} src={this.props.icon} />
            </Tooltip>
          </div>
          <DatePicker
            value={this.state.completion}
            disabled={disabled || projectCompleted}
            allowClear={false}
            onChange={val =>
              this.setState({ completion: val }, () => this.saveData())
            }
            style={{
              marginTop: 10,
              border: `1px solid ${color}`,
              width: '100%',
              height: 45,
              fontSize: 16,
              color: color,
              borderRadius: 5
            }}
            className="serviceDatePicker"
            suffixIcon={<Icon style={{ color: color }} type="calendar" />}
          />

          <div style={styles.titleDiv}>
            <h3 style={styles.title}>{t('Notes')}</h3>
          </div>
          <div
            onClick={() => disabled && this.setState({ disabledPopup: true })}>
            <TextArea
              onBlur={() => this.saveData()}
              rows={2}
              disabled={disabled || projectCompleted}
              onChange={e => this.setState({ notes: e.target.value })}
              style={{
                marginTop: 10,
                border: `1px solid ${color}`,
                fontSize: 16
              }}
              value={this.state.notes}
            />
          </div>
        </div>
        {!projectCompleted && (
          <DisabledPopup
            open={this.state.disabledPopup}
            close={() => this.setState({ disabledPopup: false })}
            color={color}
          />
        )}
        <div
          onClick={() =>
            !this.isDisabled() && !projectCompleted
              ? this.saveData(true)
              : !projectCompleted && this.setState({ disabledPopup: true })
          }
          style={
            this.isDisabled() || projectCompleted
              ? styles.disabledNextBtn
              : styles.nextBtn
          }>
          {t('Next Phase')}
        </div>
      </div>
    );
  }
}

export default Preparation;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/preparation.js